import { CandidateRole } from "src/app/models/enum";

export type Ts1CrewRoleAssignment = {
	pfCandidateId?: string;
	pmCandidateId?: string;
	rolesByCandidateIndex?: CandidateRole[];
};

/** Resolve PF/PM carousel roles from normalized candidate ids and crew assignment. */
export function resolveCrewRolesForCandidates(
	candidates: Array<{ candidateId: string }>,
	crewRoleAssignment?: Ts1CrewRoleAssignment,
): CandidateRole[] {
	if (crewRoleAssignment?.rolesByCandidateIndex?.length) {
		const roles = [...crewRoleAssignment.rolesByCandidateIndex];
		while (roles.length < candidates.length) {
			roles.push(roles.length === 0 ? CandidateRole.PF : CandidateRole.PM);
		}
		return roles.slice(0, candidates.length);
	}

	if (!candidates.length) return [CandidateRole.PF, CandidateRole.PM];
	const roles = candidates.map(() => CandidateRole.PM);
	if (crewRoleAssignment?.pfCandidateId) {
		const pfIdx = candidates.findIndex((c) => c.candidateId === crewRoleAssignment.pfCandidateId);
		if (pfIdx >= 0) roles[pfIdx] = CandidateRole.PF;
	} else if (candidates.length > 0) {
		roles[0] = CandidateRole.PF;
	}
	if (crewRoleAssignment?.pmCandidateId) {
		const pmIdx = candidates.findIndex((c) => c.candidateId === crewRoleAssignment.pmCandidateId);
		if (pmIdx >= 0) roles[pmIdx] = CandidateRole.PM;
	} else if (candidates.length > 1) {
		roles[1] = CandidateRole.PM;
	}
	return roles;
}
